// extracted by mini-css-extract-plugin
export default {"container":"JobGroupStateCounts_container__2TTj7","state":"JobGroupStateCounts_state__WXV2P"};